export const Images = {
  typescript: require("./skills/typescript.svg").default,
  react: require("./skills/react.svg").default,
  graphql: require("./skills/graphql.svg").default,
  mongodb: require("./skills/mongodb.svg").default,
  apollo: require("./skills/apollo.svg").default,
  guiginos: { webView: require("./guiginos/webView.png").default },
  tindawg: { webView: require("./tindawg/webView.png").default },
  macs: {
    webView: require("./macs/webView.png").default,
  },
};
